/**
 * 基类：用类定义的方式来声明枚举
 * 
 * @version 1.0.0
 */
export abstract class BaseEnumClass<T extends BaseEnumClass<T>> {
    protected static _allCache: any[] | null = null;

    static getAll<T extends BaseEnumClass<T>>(): T[] {
        if (!this._allCache) {
            this._allCache = Object.values(this)
                .filter((value): value is T =>
                    value instanceof (this as any)
                );
        }
        return this._allCache;
    }

    static fromCode<T extends BaseEnumClass<T> & { code: string }>(code: string): T | undefined {
        return this.getAll<T>().find(item => item.code === code);
    }

    /**
     * 检查给定的code是否存在于枚举中
     * @param code 要检查的code值
     * @returns 如果存在返回true，否则返回false
     */
    static includes<T extends { code: string }>(code: T['code']): boolean {
        return this.getAll<T>().some(item => item.code === code);
    }
}